import "@/assets/scss/bootstrap.custom.scss";
import "@/assets/scss/bootstrap.layout.scss";
import "@/assets/scss/styles.scss";
// general imports
import "flag-icons/css/flag-icons.min.css";
import "react-datepicker/dist/react-datepicker.css";

import "bootstrap";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {RouterProvider} from "react-router";
import {Router} from "@/routes/router.tsx";

// imported after the router so that colors and other styling from pulse can override the default styles of the components
import "@/assets/scss/uptime.scss";

// check router.tsx file for routes and component composition
const App = () => {
  return (
    <HelmetProvider>
      <Helmet defaultTitle="Uptime.com" titleTemplate="%s | Uptime.com" />
      <RouterProvider router={Router} />
    </HelmetProvider>
  );
};

export default App;
